var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"whatsapp",attrs:{"href":"https://wa.me/5521973764379?text=Ol%C3%A1!+Algu%C3%A9m+pode+me+ajudar+com+minha+assinatura?","target":"_blank","title":"Suporte via Whatsapp!","rel":"noopener noreferrer"}},[_c('em',{staticClass:"fa fa-whatsapp"})])])
}]

export { render, staticRenderFns }